import React from 'react'
import {cn} from '@/lib/utils'
import {GraphBarProps} from './expense-dashboard'

const GraphBar: React.FC<GraphBarProps> = ({
    title,
    className,
    barClassName,
    percent,
    value,
    valueDisplay,
    color,
    noReciepts
}) => {
    return (
        <div
            data-testid="GraphBar-Container"
            className={cn(
                'flex-[0_0_33.33333%] max-w-[33.33333%] text-center relative px-15',
                className
            )}
            data-paid-with-hsa={value}
        >
            <div
                data-testid="GraphBar-Element"
                className={cn(
                    'flex flex-col justify-end w-[61px] sm:w-[100px] mx-auto',
                    noReciepts ? 'h-[1px]' : 'h-[92px] md:h-[120px]',
                    barClassName
                )}
                data-percent={percent}
            >
                <div
                    data-testid="GraphBar-Filler"
                    className={`relative w-full bg-[${color}] transition-all duration-800 ease-in-out`}
                    style={{
                        height: noReciepts ? '100%' : percent,
                        backgroundColor: color
                    }}
                >
                    <div
                        className={`relative group text-xs font-medium leading-[18px] mt-[-30px] pl-[7px] pr-[7px] absolute left-0 top-auto w-full text-ellipsis md:text-base md:leading-[24px] md:left-1/2 md:transform md:-translate-x-1/2 md:w-auto`}
                        style={{
                            height: noReciepts ? '100%' : percent,
                            color: color
                        }}
                    >
                        <span className={cn(noReciepts && 'hidden')}>{valueDisplay}</span>
                        <span
                            data-testid="GraphBar-ValueDisplay"
                            className="absolute left-1/2 top-[-5px] transform -translate-x-1/2 -translate-y-full mb-2 hidden group-hover:block bg-black text-white text-sm rounded px-2 pt-2 pb-1 shadow-lg"
                        >
                            {valueDisplay}
                        </span>
                    </div>
                </div>
            </div>
            <div
                data-testid="GraphBar-Title"
                className="text-xs font-light leading-[13px] mt-[13px] absolute left-0 top-full w-full text-center md:text-base md:leading-[17px]"
            >
                {title}
            </div>
        </div>
    )
}

export default GraphBar
